export class SectionData {
    Id?: number;
    KeyHelp: string;
    Title: string;
    ListSubSections: SubSectionData[];

    constructor() {
        this.KeyHelp = '';
        this.Title = '';
        this.ListSubSections = [];
    }
}

export class SubSectionData {
    Id?: number;
    Title: string;
    ListRows: SubSectionRowData[];

    constructor() {
        this.Title = '';
        this.ListRows = [];
    }
}

export class SubSectionRowData {
    Id?: number;
    ContentType: string;
    Content: string;
    SecondStart: number;
    SecondEnd: number;
    Order: number;

    constructor() {
        this.ContentType = '';
        this.Content = '';
        this.SecondStart = 0;
        this.SecondEnd = 0;
        this.Order = 0;
    }
}


export class SectionDataDb {
    Id?: number;
    KeyHelp: string;
    TitleIt: string;
    TitleEn: string;
    TitleEs: string;
    TitleDe: string;
    TitleFr: string;
    TitleNl: string;
    TitlePl: string;
    TitleRu: string;
    TitleSk: string;
    Order: number;

    constructor() {
        this.KeyHelp = '';
        this.TitleIt = '';
        this.TitleEn = '';
        this.TitleEs = '';
        this.TitleDe = '';
        this.TitleFr = '';
        this.TitleNl = '';
        this.TitlePl = '';
        this.TitleRu = '';
        this.TitleSk = '';
        this.Order = 0;
    }
}


export class SubSectionDataDb {
    Id?: number;
    KeyHelp: string;
    SectionId: number;
    TitleIt: string;
    TitleEn: string;
    TitleEs: string;
    TitleDe: string;
    TitleFr: string;
    TitleNl: string;
    TitlePl: string;
    TitleRu: string;
    TitleSk: string;
    User: number;
    Technician: number;
    Service: number;
    Guest: number;
    Order: number;
    DestinationClients: string;

    constructor() {
        this.KeyHelp = '';
        this.TitleIt = '';
        this.TitleEn = '';
        this.TitleEs = '';
        this.TitleDe = '';
        this.TitleFr = '';
        this.TitleNl = '';
        this.TitlePl = '';
        this.TitleRu = '';
        this.TitleSk = '';
        this.User = 1;
        this.Technician = 1;
        this.Service = 1;
        this.Guest = 1;
        this.Order = 0;
        this.DestinationClients = 'com.came.thermosg, com.came.crpconnectapp, com.came.cameconnectapp, com.came.myaccess, com.came.installer, frontend';
    }
}


export class RowDataDb {
    Id?: number;
    SubsectionId: number;
    ContentType: string;
    ContentIt: string;
    ContentEn: string;
    ContentEs: string;
    ContentDe: string;
    ContentFr: string;
    ContentNl: string;
    ContentPl: string;
    ContentRu: string;
    ContentSk: string;
    StartSecond: number;
    EndSecond: number;
    Order: number;
}
